<script>
export default {
    about_us: {
        version: `Budget Control of MlabFactory s.r.l version `,
        personal_finance: `<b>Personal finance manager</b><p>Budget Control by MlabFactory s.r.l is a personal finance management tool that helps you track your spending, so you can stay in control and achieve your goals.</p>`,
        information: `<b>Budget Control information</b><p>MlabFactory s.r.l is a professional developer based in Italy, Milan has been operating and developing applications since 2008. Find out more about the team</p><a href="http://mlabfactory.it">MlabFactory s.r.l</a>`,
        visit_our_website: 'Visit our website',
    },
    assistance: {
        write_question: `<p>Write here your question</p>`,
        thanks: `Thank you for your request. We will get back to you as soon as possible.`,
    },
    profile: {
        policy: `<p>Registrandoti o connettendoti con uno dei suddetti servizi,acconsenti ai nostri <a class="font-bold text-decoration-line"
                    href="https://www.budgetcontrol.cloud/terms/">Termini di Servizio</a> e
                riconosci la nostra <a class="font-bold text-decoration-line"
                  href="https://www.budgetcontrol.cloud/privacy/">Informativa sulla Privacy</a>,
                che descrive come gestiamo i tuoi dati personali.</p>`
    },
    settings: {
        manage_your_workspace: 'Manage your workspaces.',
        manage_wallets: 'Manage wallets, change icons, color.',
        manage_entry: 'Manage your entry categories.',
        customize_entry: 'Customize entry labels.',
        configure_model: 'Configure entry models.',
        set_currency: 'Set your preferred currency.',
        edit_profile: 'Edit your user profile.',
        learn: 'Learn more about our team.',
        write_us: 'Write us for assistance.',
    },
    install_app: 'Hey! Install our app to get the best experience.',
    tooltips: {
        finalize: {
            workspace: "The name of your workspace, so you can identify it if you create many others",
            currency: "The default currency you use, for example Euro",
            wallet: "The name of your first wallet, for example it can also be the name of your bank",
            balance: "The starting balance of your wallet",
            payment_type: "The payment method you use most often, we will set it as default",
            wallet_type: "What type is your common wallet? A bank or simply cash? Here you can choose it to improve your statistics"
        }
    }
}
</script>